import * as React from 'react';
import { sortBasedOnList } from '../utils';

export type Table19bData = { [key: string]: { [key: string]: ITable19bRow } };

export interface ITable19bProps {
  data: Table19bData;
}

interface ITable19bRow {
  present: number;
  notPresent: number;
  vehicleOnlyPresent: number;
  notStated: number;
  notApplicable: number;
  unknown: number;
}

interface ITable19bState {
}

const sortOrder = [
  "Intermittent or Moving Work",
  "Lane Closure",
  "Lane Shift/Crossover",
  "Work on Shoulder or Median",
  "Not Applicable",
  "Other",
  "Unknown",
  "Not Stated",

  "Before Work Zone Warning Sign",
  "Advance Warning Area",
  "Transition Area",
  "Activity Area",
  "Termination Area",
  "Not Applicable",
  "Other",
  "Unknown",
  "Not Stated",
];

export default class Table19b extends React.Component<ITable19bProps, ITable19bState> {
  public constructor(props: any) {
    super(props);
  };

  componentDidMount = () => {
  }

  public render() {
    return (
      <>
        {this.props.data ?
          <table className="ss-table summaryTable1">
            <colgroup>
              <col width={28} />
              <col width={380} />
            </colgroup>
            <thead>
              <tr>
                <th colSpan={2} className="border-right-bold">
                  <div className="ss-table-header">
                    <span className="header-number">19b</span>
                    <span className="header-text">OFFICER PRESENT IN WORKZONE</span>
                  </div>
                </th>
                <th>PRESENT</th>
                <th>NOT PRESENT</th>
                <th>VEHICLE ONLY PRESENT</th>
                <th>NOT APPLICABLE</th>
                <th>UNKNOWN</th>
                <th>NOT STATED</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(this.props.data).map((key, index) =>
                sortBasedOnList(this.props.data[key], sortOrder).map((key2, index2) =>
                  <tr
                    key={key2}
                    style={index > 0 && index2 === 0 ? { borderTop: '2px solid black' } : {}}
                  >
                    {index2 === 0 &&
                      <td rowSpan={Object.keys(this.props.data[key]).length}>
                        <p
                          className="atIntersectionVerticalColumnSmall"
                          style={{ width: '15px' }}
                        >
                          {key}
                        </p>
                      </td>
                    }
                    <td className="border-right-bold">{key2}</td>
                    <td className="numberTotals">{this.props.data[key][key2].present}</td>
                    <td className="numberTotals">{this.props.data[key][key2].notPresent}</td>
                    <td className="numberTotals">{this.props.data[key][key2].vehicleOnlyPresent}</td>
                    <td className="numberTotals">{this.props.data[key][key2].notApplicable}</td>
                    <td className="numberTotals">{this.props.data[key][key2].unknown}</td>
                    <td className="numberTotals">{this.props.data[key][key2].notStated}</td>
                  </tr>)
              )}
            </tbody>
          </table>
          : <p>Loading...</p>}
      </>
    );
  }
}
